import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './comman/Header';
import Home from './pages/Home';
import ProductDetails from './pages/Product-Detail';
import Contact from './pages/Contact';
import Footer from './comman/footer';
import Aboutus  from './pages/Aboutus';
import Aboutvalue  from './pages/Aboutvalue';
import Aboutglovalreach from './pages/Aboutglovalreach';
import Aboutfacilty from './pages/Aboutfacility';
import Aboutcmdmessage from './pages/Aboutcmdmessage';
import Aboutqualitypolicy from './pages/Aboutpolicy';
import Products from './pages/Products';
import Ourhostoryofabout from './pages/Ourhistory';
import Aboutaward from './pages/Aboutaward';
import Service from './pages/Sparesserviceconatct';
import Generalenqiureconatct from './pages/Generalcontact';
import Finddealercontact from './pages/Finddealercontact';
import Salesenquire from './pages/Saleconstct';
import Dealershipenquiry from './pages/Dealershipcontact';
import Exportenquiry from './pages/Exportconatct';
import Careerdas from './pages/careeratconatct';
import Ourvision from './pages/Ourvision';




function App() {
  return (
    <div>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Product-Detail/:productSlug" element={<ProductDetails />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Aboutdsamesh" element={<Aboutus />} />
          <Route path="/Aboutvalue" element={<Aboutvalue />} />
          <Route path="/Aboutglovalreach" element={<Aboutglovalreach />} />
          <Route path="/Aboutfacility" element={<Aboutfacilty />} />
          <Route path="/Aboutcmdmessage" element={<Aboutcmdmessage />} />
          <Route path="/Aboutpolicy" element={<Aboutqualitypolicy />} />
          <Route path="/Ourvision" element={<Ourvision />} />
          <Route path="/Products" element={<Products/>} />
          <Route path="/Ourhistory" element={<Ourhostoryofabout/>} />    
          <Route path="/Aboutaward" element={<Aboutaward/>} /> 
          <Route path="/general-enqiure" element={<Generalenqiureconatct/>} />  
          <Route path="/find-dealer" element={<Finddealercontact/>} />  
          <Route path="/sales-enquiry" element={<Salesenquire/>} />  
          <Route path="/dealership-enquiry" element={<Dealershipenquiry/>} />  
          <Route path="/export-enquiry" element={<Exportenquiry/>} />  
          <Route path="/servicespare" element={<Service/>} />  
          <Route path="/career-das" element={<Careerdas/>} />  
          <Route path="/:productSlug" element={<ProductDetails />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
